import React from "react";

export function NoResults() {
    return (
        <p className="no-results">
            No results found
            <style jsx>{`
                // Override the global styles override
                p.no-results {
                    padding: 1em 0;
                    font-size: 2.5em;
                    color: #222;
                    font-weight: 600;
                    text-align: center;
                }
            `}</style>
        </p>
    );
}
